import React, { useEffect, useState } from 'react'
import { useCompetitionList } from './hooks'
import { Flex, Table } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { CButton, CCardBody } from '@coreui/react-pro'
import { Competitions } from './types'
import CIcon from '@coreui/icons-react'
import { cilZoom } from '@coreui/icons'
import { path } from '../../../../libs'

export const ParticipantsList: React.FC = () => {
  const { competitions, loading, onChangeCompetitionsList } =
    useCompetitionList()

  const [orderBy, setOrderBy] = useState('dayId')
  const [orderDirection, setOrderDirection] = useState('')
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(20)

  const handleTableChange = ({
    currentPage,
    currentPageSize,
    currentOrderBy,
    currentOrderDirection,
  }: {
    currentPage?: number
    currentPageSize?: number
    currentOrderBy?: string
    currentOrderDirection?: string
  }) => {
    if (currentPage) {
      setPage(currentPage)
    }
    if (currentPageSize) {
      setPageSize(currentPageSize)
    }
    if (currentOrderBy) {
      setOrderBy(currentOrderBy)
    }
    if (currentOrderDirection) {
      if (currentOrderDirection == 'descend') {
        setOrderDirection('-')
      } else {
        setOrderDirection('')
      }
    }
  }

  useEffect(() => {
    onChangeCompetitionsList({
      limit: pageSize,
      page: page,
      orderBy: orderBy,
      orderDirection: orderDirection,
    })
  }, [pageSize, page, orderBy, orderDirection])

  const columns: ColumnsType<Competitions> = [
    {
      title: 'Day',
      dataIndex: 'dayId',
      sorter: (a, b) => a.dayId - b.dayId,
    },
    {
      title: 'Client',
      dataIndex: 'clients',
    },
    {
      title: 'Type',
      dataIndex: 'type',
    },
    {
      title: 'Status',
      dataIndex: 'status',
    },
    {
      title: 'Actions',
      fixed: 'right',
      width: 150,
      render: (item) => {
        return (
          <div className="d-flex flex-column gap-1">
            <CButton
              color="secondary"
              href={path.promo.ramadan2026.competitions.details(item.dayId)}
            >
              <CIcon icon={cilZoom} />
            </CButton>
          </div>
        )
      },
    },
  ]

  return (
    <CCardBody>
      <Flex className="mb-3" gap={5} vertical>
        <div>
          <strong>Lots: </strong>
          {competitions.reduce((accum, current) => accum + current.sumLots, 0).toFixed(2)}
        </div>
        <div>
          <strong>Charity: </strong>
          {Math.floor(
            competitions.reduce((accum, current) => accum + current.sumLots, 0),
          )}{' '}
          USD
        </div>
      </Flex>
      <Table
        dataSource={competitions}
        bordered={true}
        scroll={{ x: true }}
        loading={loading}
        rowKey="competionsId"
        columns={columns}
        pagination={false}
        onChange={(pagination, sorter) =>
          handleTableChange({
            //@ts-ignore
            currentPage: pagination.current, //@ts-ignore
            currentPageSize: pagination.pageSize, //@ts-ignore
            currentOrderDirection: sorter.order, //@ts-ignore
            currentOrderBy: sorter.field,
          })
        }
      />
    </CCardBody>
  )
}
